import { render, staticRenderFns } from "./ActivationDeliveredContentRouterView.vue?vue&type=template&id=8f160aa2&"
import script from "./ActivationDeliveredContentRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationDeliveredContentRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports